import { NotificationBell } from './components/NotificationBell/NotificationBell';
import { useNotificationCenter } from './hooks/useNotificationCenter';
import styles from './notificationCenter.module.scss';

/**
 * Центр уведомлений в шапке. Выведен из работы: колокольчик остаётся на месте,
 * но бейдж ничем не питается, кнопка заблокирована, панель истории не
 * рендерится. Под уведомления будет отдельный сокет и отдельный сервис —
 * `NotificationPanel`, карточки и `notificationsHistoryStorage` сохранены
 * нетронутыми под него.
 *
 * Чтобы вернуть центр в работу: `IS_NOTIFICATION_CENTER_ENABLED` в
 * `useNotificationCenter` → `true` и вернуть сюда рендер панели
 * (`useClickOutside` + `AnimatePresence` + `NotificationPanel`).
 */
export const NotificationCenter: React.FC = () => {
  const { isEnabled, isOpen, unreadCount, toggle } = useNotificationCenter();

  return (
    <div className={styles['notification-center']}>
      <NotificationBell
        count={unreadCount}
        isActive={isOpen}
        isDisabled={!isEnabled}
        onClick={toggle}
      />
    </div>
  );
};
